import axios from 'axios'

import {
  GET_CHECKERS_REQUEST,
  GET_CHECKERS_SUCCESS,
  GET_CHECKERS_FAIL,
  CREATE_CHECKER_REQUEST,
  CREATE_CHECKER_SUCCESS,
  CREATE_CHECKER_FAIL,
  UPDATE_CHECKER_REQUEST,
  UPDATE_CHECKER_SUCCESS,
  UPDATE_CHECKER_FAIL,
  DELETE_CHECKER_REQUEST,
  DELETE_CHECKER_SUCCESS,
  DELETE_CHECKER_FAIL,
  ASSIGN_EVENTS_REQUEST,
  ASSIGN_EVENTS_SUCCESS,
  ASSIGN_EVENTS_FAIL,
} from '../constants/checkerConstants'
import { logout } from './userActions'

const baseUrl = process.env.REACT_APP_API_URL;

export const getCheckers = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_CHECKERS_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/admin/checkers`, config)

    dispatch({
      type: GET_CHECKERS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_CHECKERS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const createChecker = (name, email, password, role, assignedEvents) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CREATE_CHECKER_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `${baseUrl}/admin/checkers`,
      { name, email, password, role, assignedEvents },
      config
    )

    dispatch({
      type: CREATE_CHECKER_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: CREATE_CHECKER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateChecker = (id, name, email, role) => async (dispatch, getState) => {
  try {
    dispatch({
      type: UPDATE_CHECKER_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `${baseUrl}/admin/checkers/${id}`,
      { name, email, role },
      config
    )

    dispatch({
      type: UPDATE_CHECKER_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: UPDATE_CHECKER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deleteChecker = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_CHECKER_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.delete(
      `${baseUrl}/admin/checkers/${id}`,
      config
    )

    dispatch({
      type: DELETE_CHECKER_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: DELETE_CHECKER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const assignEvents = (checkerId, eventIds) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ASSIGN_EVENTS_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `${baseUrl}/admin/checkers/assign-events`,
      { checkerId, eventIds },
      config
    )

    dispatch({
      type: ASSIGN_EVENTS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ASSIGN_EVENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
